import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePc from '../views/HomePc.vue'
import GamePc from '../views/GamePc.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomePc',
    component: HomePc
  }, {
    path: '/game/:id',
    name: 'GamePc',
    component: GamePc
  }, {
    path: '/ys',
    name: 'YinSiMobile',
    component: () => import('../views/YinSiMobile.vue')
  }, {
    path: '/xy',
    name: 'XieYiMobile',
    component: () => import('../views/XieYiMobile.vue')
  }, {
    path: '/jz',
    name: 'XieYiMobile',
    component: () => import('../views/JiaZhangMobile.vue')
  }, {
    path: '/service',
    name: 'ServicePc',
    component: () => import('../views/ServicePc.vue')
  }, {
    path: '/us',
    name: 'UsPc',
    component: () => import('../views/UsPc.vue')
  }, {
    path: '/hd1',
    name: 'HuoDong1Mobile',
    component: () => import('../views/HuoDong1Mobile.vue')
  }, {
    path: '/hd_ganen',
    name: 'HuoDongGanenPc',
    component: () => import('../views/hd/HuoDongGanenPc.vue')
  }, {
    path: '*',
    component: HomePc
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
